import { Component } from '@angular/core';

import { TemplateFieldBaseComponent } from 'app/form-fields/common/template/template-field-base.component';

@Component({
  selector: 'cc-app-person',
  templateUrl: './person-template.component.html',
  styleUrls: ['./person-template.component.scss', '../../common/template/form-control.component.scss'],
})
export class PersonTemplateComponent extends TemplateFieldBaseComponent {}
